module.exports = __webpack_public_path__ + "static/site-e-commerce-99f46f51b3410e1f657da72db591fd3f.jpg";